import React from 'react';
import PropTypes from 'prop-types';
import {
  Image,
  LayoutTemplate,
} from 'lucide-react';

export const WORKFLOW_TABS = [
  { id: 'page-layout', label: 'Page layout', icon: LayoutTemplate },
  { id: 'output', label: 'Finish', icon: Image },
];

export function WorkflowTabs({ activeTab, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-1 rounded-xl border border-slate-200 bg-slate-50 p-1" aria-label="Editor workflow">
      {WORKFLOW_TABS.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          className={`flex min-h-12 min-w-0 flex-col items-center justify-center gap-0.5 rounded-lg px-1 py-1.5 text-center text-[11px] font-semibold leading-tight transition-colors ${
            activeTab === id
              ? 'bg-blue-50 text-blue-800 shadow-sm ring-1 ring-blue-100'
              : 'text-slate-600 hover:bg-white hover:text-slate-950'
          }`}
          aria-pressed={activeTab === id}
        >
          <Icon size={14} />
          {label}
        </button>
      ))}
    </div>
  );
}

WorkflowTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
